import { useLocation } from "react-router-dom";

export const getRentHeaderText = (params) => {
  const category = params.get("category");
  const building = params.get("building");

  const formatText = (text) =>
    text
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  let headingText = "Apartments & Houses For Rent";

  if (building === "true") {
    headingText = "All Rental Buildings";
  } else if (category) {
    headingText = `${formatText(category)}s For Rent`;
  }

  return headingText;
};

const RentHeader = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const headingText = getRentHeaderText(params);

  return <h6 className="mb-0">{headingText}</h6>;
};

export default RentHeader;
